import React from 'react';
import LayoutBodyWrapper from 'layouts/layout-parts/LayoutBodyWrapper';
import { Fragment, useState } from 'react';
import { Outlet } from 'react-router';
import DashboardHeader from '../layout-parts/DashboardHeader';
import DashboardSidebar from './DashboardSidebar'; // --------------------------------------------
import CanonicalUrl from 'components/CanonicalUrl';

// --------------------------------------------
interface DashboardLayoutProps {
    children?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const [sidebarCompact, setSidebarCompact] = useState<boolean>(false);
    const [showMobileSideBar, setShowMobileSideBar] = useState<boolean>(false);

    const handleCompactToggle = (): void => setSidebarCompact(!sidebarCompact);

    const handleMobileDrawerToggle = (): void => setShowMobileSideBar(state => !state); // dashboard body wrapper custom style

    const customStyle = {
        marginLeft: sidebarCompact ? `86px` : `280px`,
    };
    return (
        <Fragment>
            <CanonicalUrl />
            <DashboardSidebar
                sidebarCompact={sidebarCompact}
                showMobileSideBar={showMobileSideBar}
                setSidebarCompact={handleCompactToggle}
                setShowMobileSideBar={handleMobileDrawerToggle}
            />

            <LayoutBodyWrapper sx={customStyle}>
                <DashboardHeader setShowSideBar={handleCompactToggle} setShowMobileSideBar={handleMobileDrawerToggle} />

                {children || <Outlet />}
            </LayoutBodyWrapper>
        </Fragment>
    );
};

export default DashboardLayout;
